export default "__VITE_ASSET__CyHS24$4__"